import uitoolkit from "@zoom/videosdk-ui-toolkit";
import "@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

function ZoomApp() {
  const nav = useNavigate();
  let sessionContainer: HTMLDivElement | null = null;
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const sessionParam = "67212048537ae5ef1673610a";
  const zoomTokenParam = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfa2V5IjoicVpIdjRFVnNSS0d3VWlSaU5HYzZrZyIsInRwYyI6IjY3MjEyMDQ4NTM3YWU1ZWYxNjczNjEwYSIsInJvbGVfdHlwZSI6MCwiaWF0IjoxNzMwMjI0MjQ2LCJleHAiOjE3MzAyMzE0NDYsInRva2VuRXhwIjoxNzMwMjMxNDQ2fQ.fONNRduSpiDs_K28YVuOlWz1iU3bDVeHxfm_6pGavR8";

  const config = {
    videoSDKJWT: zoomTokenParam || "",
    sessionName: sessionParam || "",
    userName: "Patient",
    sessionPasscode: "",
    features: ["video", "audio", "settings", "users", "chat", "share"],
    options: { init: {}, audio: {}, video: {}, share: {} },
    virtualBackground: {
      allowVirtualBackground: true,
      allowVirtualBackgroundUpload: true,
      virtualBackgrounds: ["https://images.unsplash.com/photo-1715490187538-30a365fa05bd?q=80&w=1945&auto=format&fit=crop"],
    },
  };

  useEffect(() => {
    if (sessionParam && zoomTokenParam) {
      sessionContainer = document.getElementById("sessionContainer") as HTMLDivElement;
      document.getElementById("join-flow")!.style.display = "none";
      joinSession();
    }
  }, [sessionParam, zoomTokenParam]);

  function joinSession() {
    if (sessionContainer) {
      uitoolkit.joinSession(sessionContainer, config);
      uitoolkit.onSessionClosed(sessionClosed);
    }
  }

  const sessionClosed = () => {
    console.log("session closed");
    uitoolkit.closeSession(sessionContainer!);
    document.getElementById("join-flow")!.style.display = "block";
    nav("/appointment-aprove");
  };

  function getVideoSDKJWT() {
    sessionContainer = document.getElementById("sessionContainer") as HTMLDivElement;
    document.getElementById("join-flow")!.style.display = "none";
    joinSession();
  }

  return (
    <div className="ZoomApp">
      <main>
        {" "}
        <div id="join-flow">
          <button onClick={getVideoSDKJWT}>Join Session</button>
        </div>
        <div id="sessionContainer"></div>
      </main>
    </div>
  );
}

export default ZoomApp;
